import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ContactInfo {
  address: string;
  phone: string;
  email: string;
}

interface SocialMedia {
  facebook: string;
  instagram: string;
  twitter: string;
  tiktok: string;
}

interface HoursOfOperation {
  monday_thursday: string;
  friday_saturday: string;
  sunday: string;
}

interface Branding {
  logo_url: string;
  favicon_url: string;
}

export const useSiteSettings = () => {
  const [branding, setBranding] = useState<Branding>({
    logo_url: '',
    favicon_url: ''
  });

  const [contactInfo, setContactInfo] = useState<ContactInfo>({
    address: '727 Bankhead Hwy, Carrollton, GA 30117',
    phone: '(678) 664-0036',
    email: 'mexicanrestaurantjunniorstacos@gmail.com'
  });

  const [socialMedia, setSocialMedia] = useState<SocialMedia>({
    facebook: '',
    instagram: 'https://www.instagram.com/junniorstacosymas',
    twitter: '',
    tiktok: 'https://www.tiktok.com/@junniorstacosymas'
  });

  const [hours, setHours] = useState<HoursOfOperation>({
    monday_thursday: '11 AM - 9 PM',
    friday_saturday: '11 AM - 10 PM',
    sunday: '11 AM - 9 PM'
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('*');

      if (error) throw error;

      data?.forEach(setting => {
        if (setting.setting_key === 'branding') {
          setBranding(setting.setting_value as unknown as Branding);
        } else if (setting.setting_key === 'contact_info') {
          setContactInfo(setting.setting_value as unknown as ContactInfo);
        } else if (setting.setting_key === 'social_media') {
          setSocialMedia(setting.setting_value as unknown as SocialMedia);
        } else if (setting.setting_key === 'hours_of_operation') {
          setHours(setting.setting_value as unknown as HoursOfOperation);
        }
      });
    } catch (error) {
      console.error('Error fetching site settings:', error);
    } finally {
      setLoading(false);
    }
  };

  return { branding, contactInfo, socialMedia, hours, loading };
};
